// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2MMZD","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2nF8M","obliqueLine":"membershipbadge_obliqueLine__2JgAg"};